import React from "react";
import styles from "./NossosProdutos.module.css";

const NossosProdutos = () => {
  const produtos = [
    {
      id: 1,
      nome: "Produto 1",
      descricao: "Descrição do produto 1",
      imagem:
        "https://as1.ftcdn.net/v2/jpg/06/12/66/98/1000_F_612669885_nOCZzlrwcHoxTLB9svPGH1UGR08iE810.jpg",
    },
    {
      id: 2,
      nome: "Produto 2",
      descricao: "Descrição do produto 2",
      imagem:
        "https://as1.ftcdn.net/v2/jpg/06/12/66/98/1000_F_612669885_nOCZzlrwcHoxTLB9svPGH1UGR08iE810.jpg",
    },
    {
      id: 3,
      nome: "Produto 3",
      descricao: "Descrição do produto 3",
      imagem:
        "https://as1.ftcdn.net/v2/jpg/06/12/66/98/1000_F_612669885_nOCZzlrwcHoxTLB9svPGH1UGR08iE810.jpg",
    },
  ];

  return (
    <div className={styles.section} id="produtos">
      <div className={styles.header} data-aos="fade-up">
        <span className={styles.eyebrow}>Catálogo</span>
        <h1 className={styles.title}>Nossos Produtos</h1>
      </div>

      <div className={styles.grid}>
        {produtos.map((produto, index) => (
          <div
            key={produto.id}
            className={styles.card}
            data-aos="fade-left"
            data-aos-delay={index * 80}
          >
            <span className={styles.badgeIndex}>
              {String(index + 1).padStart(2, "0")}
            </span>
            <img
              src={produto.imagem}
              alt={produto.nome}
              loading="lazy"
              className={styles.image}
            />
            <div className={styles.overlay}>
              <h3 className={styles.productName}>{produto.nome}</h3>
              <p className={styles.productDesc}>{produto.descricao}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default NossosProdutos;